import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel'
import FormRichText from '../../../library/form/components/FormRichText'
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import FormSH from '../../../library/form/components/FormSH';
import FormWrapper from '../../../library/form/components/FormWrapper';

const InvTrnHeader1Editor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            contentStyle={{ width: '750px', height: "400px", overflowY: "scroll" }}
            formTitle={<FormTitle formObject={formObject} value='Order Header' />}
            formObject={formObject} >
            <ul className="uiTwoColumn">
                <FormWrapper customWrapper="li" wrapperClass="uiColumn" formObject={formObject} rowKey="" action={{ paramName: "transCat2" }} >
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat2" }} value="Type" />
                    </span>
                    <FormInput autofocus formObject={formObject} rowKey="" className="uiInput"
                        action={{
                            InputType: "ac", paramName: "transCat2", acMethod: "CategoryDetail",
                            acDepCtrl: { dparam: '%dataList.valLCat' }
                        }}
                    />
                </FormWrapper>
                <li>
                    <div className="uiColumn">
                        <span ID="costDivSupplier"  className="">
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileName" }} value="Customer" />
                            </span>

                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{
                                    InputType: "ac", paramName: "profileName", acMethod: "%dataList.acMethod", actionId: "refresh", actionParam: { updateProfile: 1 },
                                    acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 }
                                }}
                            />
                            <FormSH formObject={formObject} rowKey="" action={{
                                actionId: "new", paramName: "profileName", 
                                actionName: "proComp", actionParam: {}, containerKey: "popup"
                            }} >
                            </FormSH>
                        </span>
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transdate" }} value="Document Date" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="" 
                            action={{ InputType: "dp", paramName: "transdate" }} />
                    </div>
                </li>
                <li>
                    <FormWrapper customWrapper="div" wrapperClass="uiColumn" formObject={formObject} rowKey="" action={{ paramName: "fromLoc" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "fromLoc" }} value="From Location" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "fromLoc", acMethod: "Location", actionId: "refresh", actionParam: { updateLocation: 1 } }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="div" wrapperClass="uiColumn" formObject={formObject} rowKey="" action={{ paramName: "toLoc" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "toLoc" }} value="To Location" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "toLoc", acMethod: "Location" }} />
                    </FormWrapper>
                </li>
                <li>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "inchrgUser" }} value="Incharge User" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "inchrgUser", acMethod: "UserNames" }} />
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat" }} value="Category" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "transCat", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </div>
                </li>
                <li>
                    <div className="uiColumn" id="eWorkflowStatusContainer" >
                        <div ID="forDocumentCode" >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "documentCode" }} value="Document Code" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="documentCodeTxt" className=""
                                action={{ InputType: "input", paramName: "documentCode" }} />
                        </div>
                    </div>
                    <FormWrapper customWrapper="div" wrapperClass="uiColumn" formObject={formObject} rowKey="" action={{ paramName: "reqbydate" }} >
                        <span ID="costDivRequiredOn"  className="">
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reqbydate" }} value="Required on" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "dp", paramName: "reqbydate" }} />
                        </span>
                    </FormWrapper>
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "currencyContainer" }} >
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "currency", acMethod: "CurrencyName", acDepCtrl: { dparam: '%dataList.valLDT' } }} />
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "exchangeRate" }} value="Exchange Rate" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="exratetxt" className="uiInput"
                            action={{ InputType: "input", paramName: "exchangeRate" }} />
                    </div>
                </FormWrapper>
                <li>
                    <FormWrapper customWrapper="div" wrapperClass="uiColumn" formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} value="Budget Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "budgetCode", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </FormWrapper>
                    <FormWrapper customWrapper="div" wrapperClass="uiColumn" formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} value="Cost Center" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "costCenter", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </FormWrapper>
                </li>
                <li>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refExNo" }} value="Ref. No (Ex)" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="refExNotxt" className="uiInput"
                            action={{ InputType: "input", paramName: "refExNo" }} />
                    </div>
                    <div className="uiColumn">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refExDate" }} value="Ref. Date (Ex)" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="" id="refExDatetxt"
                            action={{ InputType: "dp", paramName: "refExDate" }} />
                    </div>
                </li>
                <li>
                    <div className="uiColumn" ID="ePurchaseNoContainer" >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refInNo" }} value="Ref. No (In)" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="refInNotxt" className="uiInput"
                            action={{ InputType: "input", paramName: "refInNo" }} />
                    </div>
                    <div className="uiColumn" ID="ePurchaseDateContainer" >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refInDate" }} value="Ref. Date (In)" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="" id="refInDatetxt"
                            action={{ InputType: "dp", paramName: "refInDate" }} />
                    </div>
                </li>
                <li>
                    <div className="uiColumn">
                        <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "billingProfile" }} >
                            <span className="uiLbl">
                                <FormLabel ID="profileTitle1" className="uiLbl" formObject={formObject} rowKey="" action={{ paramName: "billingProfile" }} value="" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "billingProfile", acMethod: "ProfileName", acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 } }} />
                            <FormSH formObject={formObject} rowKey=""
                                action={{ actionId: "new", paramName: "billingProfile",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                                 ></FormSH>
                        </FormWrapper>
                    </div>
                    <div className="uiColumn">
                        <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "deliverProfile" }} >
                            <span className="uiLbl">
                                <FormLabel ID="profileTitle2" className="uiLbl" formObject={formObject} rowKey="" action={{ paramName: "deliverProfile" }} value="" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "deliverProfile", acMethod: "ProfileName", acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 } }} />
                            <FormSH formObject={formObject} rowKey=""
                                action={{ actionId: "new", paramName: "deliverProfile",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                                 ></FormSH>
                        </FormWrapper>
                    </div>
                </li>
                <li>
                    <div className="uiColumn">
                        <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "billAdd" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "billAdd" }} value="Billing Address" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" className="uiFrmText" rows="2" cols="82" useValF="1"
                                action={{ InputType: "ac", paramName: "billAdd", acMethod: "ProfileAddress", acValidate: "0", acDepCtrl: { dptid: "%dataList.valLDT", dpid: "#billingProfile" } }} />
                        </FormWrapper>
                    </div>
                    <div className="uiColumn">
                        <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "deliverAdd" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "deliverAdd" }} value="Delivery Address" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" rows="2" cols="82" className="uiFrmText" useValF="1"
                                action={{ InputType: "ac", paramName: "deliverAdd", acMethod: "ProfileAddress", acValidate: "0", acDepCtrl: { dptid: "%dataList.valLDT", dpid: "#deliverProfile" } }} />
                        </FormWrapper>
                    </div>
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comments" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="3" cols="82" className="uiFrmText"
                        action={{ paramName: "comment" }} />
                </li>
            </ul>
        </FormDialog>
    )
}

export default withView(InvTrnHeader1Editor, "invTrnHeader", "invTrnHeader,itemDetail,docAttributeValue,invTrnTerms,invTrnTracker,invTrnFooter")